import React from 'react';
import Image from 'next/legacy/image';

import imageLogo from '../../../public/images/logo.svg';
import Link from 'components/CustomLink';

const Logo: React.FC = () => {
  return (
    <div className="md:pt-[5px] xl:pt-[8px] pr-[1px] s:w-44 w-40 md:w-52 lg:w-60 flex-none">
      <Link passHref href="/" className="md:pb-4 md:pt-6 p-[1px]">
        <Image src={imageLogo} alt="logo" priority width={230} height={15} />
      </Link>
    </div>
  );
};

export default Logo;
